import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy, Input, ViewChild } from '@angular/core';
import { UserService } from "../../../Shared/Services/user.service";
import { default as GridColumnsJSON } from './processed-transactions-columns.json';
import { APIURL } from "../../../Shared/Constant/API_Urls";
import { GridService } from "../../../Shared/Services/grid.service";
import { HttpErrorResponse } from "@angular/common/http";
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { MessageService } from 'primeng/api';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';
import { CommonModule, NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { Table, TableModule } from 'primeng/table';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { QuickviewSidebarComponent } from 'app/Shared/Component/quickview-sidebar/quickview-sidebar.component';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';

@Component({
  selector: 'app-processed-transactions',
  imports: [CommonModule, MatProgressSpinner, ToastModule, ExportToCSVSComponent, QuickviewSidebarComponent,
    TableModule, NgClass, ButtonModule, DialogModule, FormsModule, MatTooltipModule
  ],
  templateUrl: './processed-transactions.component.html',
  styleUrls: ['./processed-transactions.component.scss']
})
export class ProcessedTransactionsComponent implements OnInit, OnChanges, OnDestroy {
   @ViewChild(('dt')) dt!: Table |any;
  quickFilterArray: any = GridColumnsJSON["Quick-Search-Fields"];
  @Input('defaultFilters') DefaultFilterArray: any = [];
  GridColumns: any = GridColumnsJSON["Grid-Columns"];
  exportGridColumns: any = [];
  cols: any = [];
  isQuickViewOpenClose: boolean = false;
  Dataset: any[] = [];
  LastExecutionODRDate!: any[];
  isLoadingResults = false;
  PageName = "Processed_Transactiions";
  Limit: any = { 'Start': '', 'End': '' };
  selectedRow: any = [];
  totalRecords: any;
  rowcount!: number;
  startLimit: any = 0;
  pageNumber: any = 1;
  priviousStartLimit: any;
  endLimit!: number;
  subscription!: Subscription;
  columnJson: any = [];
  filterCols: any = [];
  transactionArray:any
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  defaultData: any;


  constructor(
    private userService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private sortPipe: SortPipe,) {
  }

  ngAfterViewInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    this.exportGridColumns = this.GridColumns.filter((Obj: { excludeFromExport: any; }) => !Obj.excludeFromExport);
    this.rowcount = this.gridService.getGridRowsCount();
    this.endLimit = this.rowcount;
    this.Limit = { 'Start': '0', 'End': this.endLimit };
    this.totalRecords = this.rowcount;
    this.Dataset = [];
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
    this.getColumns();
  }

  getColumns() {
    let column: any = this.GridColumns;
    this.columnJson = [];
    if (column != null || column != undefined) {
      this.columnJson = this.gridService.getGridColumns(column);
      this.cols = this.gridService.getGridColumns(column);
      this.filterCols = this.cols;
    }
  }

  onView(index: any, row: any) {
    this.isQuickViewOpenClose = false;
    this.selectedRow = [];
    this.selectedRow.push(row);
    this.isQuickViewOpenClose = true;

  }

  QuickViewCloseEvent(event: any) {
    this.selectedRow = [];
    this.isQuickViewOpenClose = false;
  }


  changePage(event: { first: any; rows: number; }) {
    this.startLimit = event.first;
    this.rowcount = event.rows;
    this.endLimit = this.startLimit + this.rowcount;

    if (this.endLimit > this.totalRecords) {
      this.endLimit = this.totalRecords;
    }
    this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    this.priviousStartLimit = this.startLimit;
    this.pageNumber = Math.round(this.startLimit / this.rowcount) + 1;
    this.getData();
  }

 sort(event:any) {
    if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
      this.sortClickCounter = this.sortClickCounter + 1;
    } else {
      this.sortClickCounter = 1;
    }
    if(this.sortClickCounter !== 3) {
      let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
      this.sortData.field = event.multisortmeta[0].field;
      this.sortData.order = sortOrder;
      this.Dataset = this.sortPipe.transform(this.Dataset, this.sortData.order, this.sortData.field);
    } else {
      if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
      this.dt.multiSortMeta[0].field = '';
      this.dt.multiSortMeta[0].order = 0;
      }
    }
    
  }
  
  onViewOrderID(rowData:any){
    this.emitterService.isODROrderViewerOpenCloseEvent.emit(
        {
          display: true,
          rowData: rowData,
          pageName: 'ODR'
        });
  }

  getData(filterArr?:any) {
    let FilterArray = filterArr ? filterArr : this.DefaultFilterArray;
    this.isLoadingResults = true;
    this.gridService.prepareData(APIURL.ODR_Processed_Transactiions, FilterArray, this.Limit, "Processed_Transactiions")
      .subscribe({
        next: (Element: any) => {
          this.isLoadingResults = false;
          let dataset: any = Element;
          this.Dataset = dataset.Data;
          this.totalRecords = dataset.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        }, error: (err: HttpErrorResponse) => {
          this.Dataset = [];
          this.totalRecords = 0;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.isLoadingResults = false;
        }
      });

  }




  exportToCSV(event: { isExportMaxRows: any; gridColumn: any; }) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    if (event.isExportMaxRows) {
      this.Limit = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
    } else {
      this.Limit = { 'Start': this.startLimit, 'End': this.rowcount };
    }
    this.gridService.getData(
      APIURL.ODR_Processed_Transactiions,
      this.DefaultFilterArray,
      this.Limit,
      this.gridService.getEventsList(this.DefaultFilterArray, 'type'),
      this.PageName
    ).subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        let data = dataset.Data;
        let column = event.gridColumn;
        data = data.map((row: any) => {
          let newRow: any = {};

          column.forEach((col: any) => {
            let value = row[col.db_columnname];
            if (col.datatype === 'float') {
              newRow[col.db_columnname] = this.convertFloatValue(value);
            }
            else {
              newRow[col.db_columnname] = value;
            }
          })
          return newRow;
        })

        if (data.length > 0) {
          data.forEach((col: { originalJSON: any; }) => {
            delete col.originalJSON;
          });
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'RSMS_' + this.PageName + '_' + this.userService.getyyyyMMddDateFormate(new Date()),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
            filename: this.userService.getActiveMPID() + '_RSMS_' + this.PageName + '_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
          };
          const csvData = this.constantService.getExportData(data, event.gridColumn);
          const csv = generateCsv(options)(csvData);
          const blob = asBlob(options)(csv);
          saveAs(blob, options.filename);
          this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
          this.userService.logUserActivity('Export CSV', null, {
            'Text1': 'No data found',
            'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
          });
        }
        this.emitterService.exportToCSVData.emit(true);
      }, error: (err: HttpErrorResponse) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'Error while Exporting',
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
        });
      }
    });
  }
getTransactionTypeMethod(){
  let transactionFilter = this.DefaultFilterArray.find((item:any)=>
  item.columnname == 'transaction');
  return transactionFilter?.values || [];
}

  convertFloatValue(value: any) {
    if (value === null || value === "") {
      return 0;
    }
    return value;
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

}